import { render, staticRenderFns } from "./ChartPage.vue?vue&type=template&id=382088fd&scoped=true&"
import script from "./ChartPage.vue?vue&type=script&lang=js&"
export * from "./ChartPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382088fd",
  null
  
)

export default component.exports